export const SEAT_BOOK_STATUS_CONFIRMED = 'book.confirmed';
export const SEAT_BOOK_STATUS_CANCELED = 'book.canceled';
export const SEAT_BOOK_STATUS_REFUSED = 'book.refused';
export const SEAT_BOOK_STATUS_PENDING_PAYMENT = 'book.pending_payment';
export const SEAT_BOOK_STATUS_PENDING_CONFIRMATION = 'book.pending_confirmation';